import Highcharts from "highcharts";

import "./charts/assessment_statuses_chart";
import "./charts/control_categories";
import "./charts/control_family_risk_profile";
import "./charts/domain_risk_profile";
import "./charts/level_chart";
import "./charts/risk_profile";
import "./charts/risk_by_rank";
import "./charts/risk_by_domain";
import "./charts/capability_level_distribution";
import "./charts/cmmc_levels_by_entity";
import "./charts/level_and_process";
import "./charts/level_control_count";
import "./charts/recon_rating_bar";
import "./charts/timeline";

Highcharts.setOptions({
  chart: {
    style: {
      fontFamily: "helvetica",
    },
  },
  credits: {
    enabled: false,
  },
  palette: {
    colorScheme: "light",
  },
});
